export enum FieldsModelType {
  AssignedTeam = 'assignedTeams',
  MileStoneStatus = 'mileStoneStatuses',
  ActionCategory = 'actionCategories',
  ActionPriority = 'actionPriorities',
  MeetingTypeOrigin = 'meetingTypeOrigins',
  HelpNeeded = 'helpNeededOptions',
  MileStoneWorkload = 'mileStoneWorkloads',
  SolutionArea = 'solutionAreas',
  CustomIndustry = 'customIndustries',
  Industry = 'industries',
  EOU = 'eous',
  RequestType = 'requestType',
}

export enum FieldsPlaceholder {
  SelectMilestoneStatus = 'Select Milestone Status',
  SelectActionCategory = 'Select Action Category',
  SelectPriority = 'Select Priority',
  SelectMeetingType = 'Select Meeting Type',
  MeetingSubType = 'Select Meeting Sub Type',
  SubRegion = 'Select Field Subsidiary',
  SelectHelpNeeded = 'Select Help Needed',
  SelectMilestoneWorkload = 'Select Milestone Workload',
  SelectSolutionArea = 'Select Solution Area',
  SelectCustomIndustry = 'Select Custom Industry',
  SelectIndustry = 'Select Industry',
  SelectOpportunityStage = 'Select Opportunity Stage',
  SelectEOU = 'Select EOU',
  PrimaryWorkload = 'Select PrimaryWorkload',
  HasFastTrack = 'Select HasFastrack',
  HasUnified = 'Select HasUnified',
  HasD365DEEDE = 'Select Has D365 DE/EDE',
  PrimaryEscalationReason = 'Select Primary Escalation Reason',
  SecondaryEscalationReason = 'Select Secondary Escalation Reason',
  TertiaryEscalationReason = 'Select Tertiary Escalation Reason ',
  Program = 'Select Program',
  Status = 'Select Status',
  IntentToMoveToCloud = 'Select Intent to move to Cloud',
  InterestedInAssessment = 'Select Interested in assessment',
  AssessmentType = 'Select Assessment type',
  Partner = 'Select Shared Partner',
  ECIFStatusIfCMA = 'Select ECIF status if CMA/AMA',
  ECIFStatusForFAM = 'Select ECIF status for FAM',
  AssessmentServiceStatus = 'Select Assessment service status',
  CompletionStatusIfCombined = 'Select Completion status if combined',
  InterestedInOtherECIF = 'Select Interested in other ECIF',
  IfYesStateReason = 'Select If yes, state reason',
  ECIFStatus = 'Select ECIF Status',
  ECIFRequestedServiceStatus = 'Select ECIF requested service status',
  InterestedInAssistedMigraion = 'Select Is assisted migration an option?',
  MigrationServiceStatus = 'Select Migration Service Status',
  MigrationType = 'Select Migration Type',
  InterestedInRenewing = 'Select Interested In Renewing',
  IfNoStateReason = 'Select If no, state reason',
  PDM = 'Select Primary PDM',
  OfferRelated = 'Offer Related',
  SelectOpportunityStatus = 'Select Opportunity Outcome',
  SelectOpportunityOutcomeStatus = 'Select Opportunity Status',
  SelectSOObjective = 'Select E&O Objective',
  SelectNomination = 'Select Nomination',
  SelectProjectName = 'Select Project Name',
  SelectListeningCircleArea = 'Select Listening Circle Area',
  EnterProjectName = 'Enter Project Name',
  EnterListeningCircleSessionName = 'Enter Listening Circle Session Name',
  Category = 'Select Category',
  BusinessImpact = 'Click to add Business Impact',
  BusinessDivision = 'Business Division',
  SelectRequestType = 'Select Request Type',
  SelectDeliveryMethod = 'Select Delivery Method',
  SelectEntityType = 'Select Entity Type',
  SelectEventType = 'Select Event Type',
  SelectMarketingPlay = 'Select Marketing Play',
  SelectLeadSourceType = 'Select Lead Source Type',
  SelectActionownerGroup = 'Select Action Owner Group',
  SelectState = 'Select State',
  SelectSubState = 'Select Sub State',
  SelectWorkscopeItem = 'Select Workscope Item',
  SelectMeetingQuarter = 'Select Meeting Quarter',
  SelectSegment = 'Select Segment(s)',
  SelectMeetingMonth = 'Select Meeting Month',
  SelectMeetingFiscalYear = 'Select Meeting Fiscal Year',
  SelectImpactType = 'Select Impact Type',
}

export enum FieldsPropertyName {
  //#region Details Tab
  areaPath = 'areaPath',
  mileStoneStatus = 'mileStoneStatus',
  actionCategory = 'actionCategory',
  actionPriority = 'actionPriority',
  meetingTypeOrigin = 'meetingTypeOrigin',
  helpNeeded = 'helpNeeded',
  milestoneWorkload = 'milestoneWorkload',
  solutionArea = 'solutionArea',
  customIndustry = 'customIndustry',
  industry = 'industry',
  //#endregion

  cceCategory = 'cceCategory',
  topic = 'topic',
  source = 'source',
  eou = 'eou',
  program = 'program',
  csrPrimaryWorkload = 'CSR Primary Workload',
  status = 'status',
  intentToMoveToCloud = 'intentToMoveToCloud',
  interestedInAssessment = 'interestedInAssessment',
  assessmentTypeCloud = 'assessmentTypeCloud',
  partner = 'partner',
  ecifStatusIfCMA = 'ecifStatusIfCMA',
  ecifStatusForFAM = 'ecifStatusForFAM',
  assessmentServiceStatus = 'assessmentServiceStatus',
  completionStatusIfcombined = 'completionStatusIfcombined',
  interestedInOtherECIF = 'interestedInOtherECIF',
  ifYesStateReason = 'ifYesStateReason',
  ecifStatus = 'ecifStatus',
  ecifRequestedServiceStatus = 'ecifRequestedServiceStatus',
  isAssistedMigrationAnOption = 'isAssistedMigrationAnOption',
  migrationServiceStatus = 'migrationServiceStatus',
  migrationType = 'migrationType',
  interestedInRenewing = 'interestedInRenewing',
  ifNoStateReason = 'ifNoStateReason',
}

export enum FieldConstants {
  createSharedViewFlightName = 'CreateSharedView',
  createSystemViewFlightName = 'CreateSystemView',
  OCPFlight = 'OCPFlight',
  ChatGPT = 'ChatGPT',
  raidAccess = 'RAIDAccess',
}

export enum GPSFieldConstant {
  GPSInvestmentsOwner = 'Actions/GPS/View',
  GPSInvestmentsAdmin = 'Actions/GPS/Admin',
  GPSInvestmentsEdit = 'Actions/GPS/Edit',
  GPSInvestmentsBPO = 'Actions/GPS/BPO',
}

export enum AzureAICapacityRoles {
  AzureAICapacityUser = 'AzureAICapacityUser',
}

export enum AzureAICapacityScopes {
  Edit = 'Actions/AzureAICapacity/Edit',
}

// RAID short-field names for GPS (Partner Investments) columns that are surfaced in the
// "Excel (For Import)" export but are not present in CommonSvcGetValidationColumnMapper.
// Referenced by SUPPLEMENTAL_FIELD_MAP in gpsExportColumns.ts to avoid hardcoded strings.
export enum GPSExportFieldName {
  InvestmentComplexity = 'gps_investmentcomplexity',
  IsIncentiveTargetingSuite = 'gps_isincentivetargetingsuite1',
  Coop = 'gps_coop',
  CalcReviewCompleted = 'gps_calcreviewcompleted',
  CalcReviewDate = 'gps_calcreviewdate',
  CalcReviewNeeded = 'gps_calcreviewneeded',
  ComplexityDrivers = 'gps_complexitydrivers',
  ComplexityLevel = 'gps_complexitylevel',
  EarningType = 'gps_earningtype',
  ExecutionGovernance = 'gps_executiongovernance',
  PaymentLever = 'gps_paymentlever',
  PaymentProgram = 'gps_paymentprogram',
  PaymentMethod = 'gps_paymentmethod',
  PaymentFrequency = 'gps_paymentfrequency',
  FinalPaymentMilestone = 'gps_finalpaymentmilestone',
  TCType = 'gps_tctype',
  GLCode = 'gps_glcode',
  PCCode = 'gps_pccode',
  AccountingTreatment = 'gps_accountingtreatment',
  DataSourceOwner = 'gps_datasourceowner',
  EFRApprovedDate = 'gps_efrapproveddate',
}

export enum RoBFieldConstant {
  RoBGsocAgentAndCoreTeam = 'Actions/RoB/Views/All',
  RoBStakeholder = 'Actions/RoB/Views',
  RoBUserActionOwner = 'Actions/RoB/Owner-Accexec-Req',
  RoBUserAtMention = 'Action/RoB/AtMentionedUser',
}

export enum RoBRoles {
  RoBGsocAgentAndCoreTeam = 'RoBGsocAgentAndCoreTeam',
  RoBStakeholder = 'RoBStakeholder',
  RoBUser = 'RoBUser',
}

export enum AzureISVRoles {
  AzureISVApprover = 'AzureISVApprover',
  AzureISVAdmin = 'AzureISVAdmin',
  AzureISVSupport = 'AzureISVSupport',
}

export enum ACOPIRRoles {
  ACOPIRApprover = 'ACOPIRApprover',
  ACOPIRdmin = 'ACOPIRdmin',
  ACOPIRSupport = 'ACOPIRSupport',
  ACOPIRUser = 'ACOPIRUser',
}

export enum PMYTFiedConstant {
  PMYTEdit = 'Actions/PMYT/Edit',
  PMYTAdmin = 'Actions/PMYT/All',
}

export enum SGSRoles {
  SGSFieldEditor = 'SGSFieldEditor',
}

export enum CorpGCSSARoles {
  CorpGCSSAUser = 'CorpGCSSAUser',
}

export enum RegionalSkillingRoles {
  RSFieldEditor = 'RegionalSkillingUser',
}

export enum MEARoles {
  MEABedrockAdmin = 'MEABedrockAdmin',
}

export enum MSecRRoles {
  MSecRUser = 'MicrosoftSecurityResearchUser',
}

// Generated by GitHub Copilot | Updated on: 2026-04-07 | 4 lines modified | Added CorpGCSSARoles enum for Corp GCS SA security group role check
// Generated by GitHub Copilot | Updated on: 2026-07-17 | 24 lines modified | Bug#141324: add GPSExportFieldName enum of GPS RAID short-field names referenced by the Excel (For Import) SUPPLEMENTAL_FIELD_MAP
// Generated by GitHub Copilot | Updated on: 2026-08-18 | 1 line removed | Removed marketplaceTenantFlightName (retired MarketplaceAccess flight)
// Generated by GitHub Copilot | Updated on: 2026-08-28 | 3 lines added | Added Azure AI Capacity manager role
// Generated by GitHub Copilot | Updated on: 2026-08-28 | 1 line modified | Associated manager role with GPS Investments
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 1 line modified | Updated Azure AI authorization token
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 1 line modified | Renamed Azure AI role enum
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 3 lines added | Added Azure AI edit scope
